import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { Button, Select, Stack } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useParams } from "react-router-dom";
import FactoryVendorEditor from "../FactoryVendorEditor";
import OrderCategory from "../OrderCategory";
import NumericEditor from "../NumericEditor";

//import FactoryEditor from "../factoryEditor";

const CustomerVendorRelation = (props) => {
  const gridRef = useRef();
  const [rowData, setRowData] = useState([]);
  const [error, setError] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [saveDisable, setSaveDisable] = useState(true);
  const [previousSelectedRows, setPreviousSelectedRows] = useState([]);
  const [updateData, setUpdateData] = useState([]);

  const params = useParams();

  const [customerVendorColumn, setCustomerVendorColumn] = useState([
    {
      field: "factoryVendor",
      headerName: "Product Type",
      cellEditor: FactoryVendorEditor,
    },
    {
      field: "orderCategory",
      headerName: "Order Type",
      cellEditor: OrderCategory,
    },
    {
      field: "customerRefNumber",
      headerName: "Customer Ref. Number",
      cellEditor: NumericEditor,
    },
    { field: "vendorId", hide: true },
  ]);

  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;

  useEffect(() => {
    setRowData(props.saveCustomerVendor);
  }, [props.saveCustomerVendor]);

  const addNewCustomerVendor = async () => {
    const newRow = {
      vendorId: "",
      factoryVendor: "",
      orderCategory: "",
      customerRefNumber: "",
    };
    const correctRowIndex = gridRef?.current?.api?.applyTransaction({
      add: [newRow],
    });
    gridRef?.current?.api?.refreshCells();
    let index = rowData.length;
    const nextIndex = [];  
    const updatedRowData = [...rowData, newRow];
    setRowData(updatedRowData); 
    const NewData = nextIndex.push(newRow)
    setUpdateData(NewData)
    setTimeout(() => {
      gridRef?.current?.api?.setFocusedCell("factoryVendor");
      gridRef?.current?.api?.startEditingCell({
        rowIndex: correctRowIndex?.add[0]?.rowIndex,
        colKey: "factoryVendor",
      });
    }, 800);
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const findDuplicates = (rowData, selectedRow) => {
    const count = rowData.filter(
      (row) =>
        row.factoryVendor === selectedRow.factoryVendor &&
        row.orderCategory === selectedRow.orderCategory
    ).length;
    const countRows = 1;
    return count > countRows;
  };

  const handleSave = async () => {
    setSuccessMsg("");
    const duplicates = findDuplicates(rowData, selectedRows[0]);
    if (updateData === 1) {
      try {
        if (duplicates) {
          setError("Product and order type combination is already exist.");
        } else {
          let models = rowData?.map((item) => ({
            vendorId: item?.vendorId?.toString(),
            factoryVendor: item?.factoryVendor,
            orderCategory: item?.orderCategory,
            customerRefNumber: item?.customerRefNumber,
          }));
          const transformedData = {
            vendorCustomerRef: models,
          };
          let insertVendor = await OAuthService.updateData(
            url,
            params.id,
            transformedData
          );
          setRowData(insertVendor?.data?.vendorCustomerRef);
          setError("");
          setSuccessMsg("Customer vendor added successfully");
          setUpdateData([])
          setSelectedRows();
        }
      } catch (error) {
        setError(error.message);
      }
    } else {
      try {
        if (duplicates) {
          setError("Product and order type combination is already exist.");
        } else {
          const updatedRowData = rowData.map((row) => {
            if (row.vendorId === selectedRows[0]?.vendorId?.toString()) {
              return {
                ...row,
                vendorId: selectedRows[0]?.vendorId?.toString(),
                factoryVendor: selectedRows[0]?.factoryVendor,
                orderCategory: selectedRows[0]?.orderCategory,
                customerRefNumber: selectedRows[0]?.customerRefNumber,
              };
            }
            return row;
          });
          const transformedData = {
            vendorCustomerRef: updatedRowData,
          };
          let updateVendor = await OAuthService.updateData(
            url,
            params.id,
            transformedData
          );
          setRowData(updateVendor?.data?.vendorCustomerRef);
          setError("");
          setSuccessMsg("Customer vendor updated successfully");
          setSelectedRows();
        }
      } catch (error) {
        setError(error.message);
      }
    }
  };

  useEffect(() => {
    props.setAllSuccessMsg(successMsg);
  }, [successMsg, props.setAllSuccessMsg]);

  useEffect(() => {
    props.setAllErrorMsg(error);
  }, [error]);

  const handleDelete = async () => {
    setSuccessMsg("");
    try {
      const updatedData = rowData.filter((row) => !selectedRows.includes(row));
      const transformedData = {
        vendorCustomerRef: updatedData,
      };
      let deleteVendor = await OAuthService.updateData(
        url,
        params.id,
        transformedData
      );
      setRowData(deleteVendor?.data?.vendorCustomerRef);
      setSelectedRows([]);
      setSuccessMsg("Customer vendor deleted successfully");
      setError("");
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };

  const onCellValueChanged = () => {
    let saveDisable = true;
    if (selectedRows?.length > 0) {
      if (
        selectedRows[0]?.factoryVendor !== "" &&
        selectedRows[0]?.orderCategory !== "" &&
        selectedRows[0]?.customerRefNumber !== ""
      ) {
        saveDisable = false;
      } else {
        saveDisable = true;
      }
    } else {
      saveDisable = true;
    }
    setSaveDisable(saveDisable);
  };
  useEffect(() => {
    let saveDisable = true;
    if (selectedRows && selectedRows.length > 0) {
        const noChanges = JSON.stringify(selectedRows) === JSON.stringify(previousSelectedRows);
        if (noChanges) {
            saveDisable = true;
        } else {
            saveDisable = false;
        }
    }
    setSaveDisable(saveDisable);
    setPreviousSelectedRows(selectedRows)
}, [selectedRows, previousSelectedRows]);

  
  return (
    <>
      {props.saveCustomerVendor && (
        <>
        {!props.hasIamRole &&(
          <>
          <Button
            className="mb-10 float-right"
            variant="contained"
            color="secondary"
            onClick={handleDelete}
            disabled={!selectedRows?.length > 0}
          >
            <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
          </Button>

          <Button
            className="mb-10 mr-10 float-right"
            variant="contained"
            color="secondary"
            onClick={handleSave}
            disabled={saveDisable ||selectedRows?.length > 1}
          >
            <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
          </Button>
          <Button
            className="mb-10 mr-10 float-right"
            variant="contained"
            color="secondary"
            onClick={addNewCustomerVendor}
            disabled={selectedRows?.length > 1}
          >
            <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
          </Button>
            </>
        )}
          <Stack className="w-[100%] h-[550px]">
            <AgGridTable
              rowData={rowData}
              columnDefs={customerVendorColumn}
              rowSelection={"multiple"}
              gridRef={gridRef}
              onCellValueChanged={onCellValueChanged}
              onSelectionChanged={onSelectionChanged}
            />
          </Stack>
        </>
      )}
    </>
  );
};
export default CustomerVendorRelation;
